import React, { useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Box, Grid, CircularProgress } from '@mui/material';
import { RIStyles } from 'pages/reference-implementation/Style';
import { CssTextField } from 'pages/reference-implementation/components/select';
import { endPoints } from 'api/endpoints';
// import { getEndpointForCatalogCode } from 'pages/reference-implementation/utils';
import useDebounce from 'pages/reference-implementation/provisioning/RI004O/hooks/use-debounce';
import Btn from 'components/button';
import { useMutation } from 'react-query';
import axios from 'api/request';
import { commonStyles as style } from 'assets/style';

const ServiceBus = (props) => {
    const { resource, handleDrawerAction, order } = props;

    // const { catalogCode } = useParams();
    // const riEndpoints = getEndpointForCatalogCode(catalogCode);

    const [formData, setFormData] = useState({
        namespace: resource?.configureData?.namespace || '',
    });
    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});

    const ValidateServiceNameApi = useMutation((payload) => axios.post(endPoints.riServices.RIIOTEVENTHUB.validateServiceBusNamespace, payload));

    const debouncedInputValue = useDebounce(formData?.namespace, 500);

    const validateForm = () => {
        const newErrors = {};
        // Validate serviceBus Name
        if (!formData.namespace && !errors?.namespace) {
            newErrors.namespace = { type: 'required', message: 'service Bus Name Space is required' };
        }
        if (formData.namespace && errors?.namespace) {
            newErrors.namespace = { type: 'required', message: errors?.namespace?.message };
        }

        setErrors(newErrors);
        return { isValid: Object.keys(newErrors).length === 0, errors: newErrors };
    };

    const handleOnSelectChange = (key, value) => {
        setFormData({
            ...formData,
            [key]: value,
        });
        setTouched({
            ...touched,
            [key]: true,
        });
    };

    const handleSubmit = () => {
        // Set all fields as touched to trigger validation errors display
        setTouched({
            namespace: true,
        });
        const checkFormValid = validateForm();
        if (!ValidateServiceNameApi?.isLoading) handleDrawerAction('save', formData, checkFormValid);
    };

    const shouldShowError = (field) => {
        return touched[field] && !!errors[field];
    };

    const saveButton = () => (
        <Btn className="custom-btn" sx={style.modalSaveButton} variant="contained" color="cmpPrimary" onClick={() => handleSubmit()} data-testid="save-btn">
            Save
        </Btn>
    );
    const cancelButton = () => (
        <Btn
            className="custom-btn"
            sx={style.modalCancelButton}
            variant="outlined"
            color="cmpPrimary"
            onClick={() => handleDrawerAction('cancel')}
            data-testid="cancel-btn"
        >
            Cancel
        </Btn>
    );

    useEffect(() => {
        if (Object.keys(touched).length > 0) {
            validateForm();
        }
    }, [formData]);

    useEffect(() => {
        if (ValidateServiceNameApi?.data?.isSuccess === true) {
            setErrors({ ...errors, namespace: '' });
        }
        if (ValidateServiceNameApi?.data?.isSuccess === false) {
            setErrors({ ...errors, namespace: { type: 'required', message: ValidateServiceNameApi?.data?.messages[0] } });
        }
    }, [ValidateServiceNameApi?.isSuccess]);

    useEffect(() => {
        if (debouncedInputValue && debouncedInputValue !== null && debouncedInputValue !== '' && debouncedInputValue !== undefined) {
            ValidateServiceNameApi.mutate({
                sector: order?.sector,
                environment: order?.environment,
                catalogServiceCode: 'RI004',
                division: order?.division || null,
                applicationRegion: order?.region || null,
                name: debouncedInputValue,
            });
        }
    }, [debouncedInputValue]);

    return (
        <Box style={RIStyles.tags.wrapper}>
            <Box sx={RIStyles.tags.contentWrapper}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <CssTextField
                            size="small"
                            fullWidth
                            autoComplete="off"
                            placeholder="Namespace"
                            label="Namespace *"
                            value={formData?.namespace || ''}
                            onChange={(e) => handleOnSelectChange('namespace', e?.target?.value)}
                            className={shouldShowError('namespace') ? 'validate' : ''}
                            error={shouldShowError('namespace')}
                            helperText={shouldShowError('namespace') && errors.namespace.type === 'required' ? errors.namespace.message : ''}
                            InputProps={{
                                endAdornment: <>{ValidateServiceNameApi?.isLoading && <CircularProgress color="inherit" size={16} />}</>,
                            }}
                        />
                    </Grid>
                </Grid>
            </Box>
            <Box className="footer" sx={RIStyles.tags.actionWrapper} gap={2}>
                {saveButton()}
                {cancelButton()}
            </Box>
        </Box>
    );
};

ServiceBus.propTypes = {
    resource: PropTypes.any,
    handleDrawerAction: PropTypes.func,
    order: PropTypes.any,
};

ServiceBus.defaultProps = {
    resource: null,
    handleDrawerAction: PropTypes.func,
    order: {},
};

export default ServiceBus;
